<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="客户管理">
      <template v-if="hasPermission('配置-客户管理-新增')">
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="newlyAdded"
          >新增客户</el-button
        >
      </template>
    </pageTitle>
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @sortChange="sortChange"
    >
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center; gap: 8px">
          <template v-if="hasPermission('配置-客户管理-编辑')">
            <div class="button" @click="editButton(row.row)">
              <i class="iconfont icon-bianji"></i> 编辑
            </div>
          </template>

          <template v-if="hasPermission('配置-客户管理-编辑')">
            <div class="button" @click="switchingStates(row.row)">
              <i
                :class="
                  row.row.status == 1
                    ? 'iconfont icon-lock'
                    : 'iconfont icon-jihuo'
                "
              ></i
              >{{ row.row.status == 0 ? "锁定" : "激活" }}
            </div>
          </template>

          <template v-if="hasPermission('配置-客户管理-删除')">
            <div class="button" @click="deleteRows(row.row)">
              <i class="iconfont icon-shanchu"></i> 删除
            </div>
          </template>

          <template v-if="hasPermission('配置-客户管理-编辑')">
            <div class="button" @click="recharge(row.row)">
              <i class="el-icon-upload2"></i> 充值
            </div>
          </template>
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>

    <!-- 充值弹窗 -->
    <el-dialog
      title="客户充值"
      :visible.sync="rechargeDialog.visible"
      custom-class="addProductPopUpWindow"
      :close-on-click-modal="false"
      width="500px"
      append-to-body
    >
      <el-form
        ref="rechargeForm"
        :model="rechargeDialog"
        :rules="rechargeRules"
        label-position="top"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="客户名称">
              <el-input
                v-model="rechargeDialog.customer_name"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="充值金额" prop="amount">
              <el-input
                v-model="rechargeDialog.amount"
                type="number"
                placeholder="请输入充值金额"
                min="0.01"
                step="0.01"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="充值账户" prop="account_id">
              <el-select
                v-model="rechargeDialog.account_id"
                placeholder="请选择充值账户"
                style="width: 100%"
                filterable
                clearable
              >
                <el-option
                  v-for="item in accountList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="rechargeDialog.remark"
                type="textarea"
                placeholder="请输入备注信息"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rechargeDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="submitRecharge">确定充值</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  customerGetList,
  customerDel,
  customerActive,
  customerLock,
  companyAccountGetList,
} from "@/api/basicConfiguration";
import { billAdd } from "@/api/bill";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "customerManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      compId: null,
      userId: null,
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 充值弹窗参数
      rechargeDialog: {
        visible: false,
        customer_id: "",
        customer_name: "",
        account_id: "",
        amount: "",
        remark: "",
      },
      // 充值表单验证规则
      rechargeRules: {
        account_id: {
          required: true,
          message: "请选择充值账户",
          trigger: "change",
        },
        amount: [
          {
            required: true,
            message: "请输入充值金额",
            trigger: "blur",
          },
          {
            type: "number",
            min: 0.01,
            message: "充值金额必须大于0",
            trigger: "blur",
          },
        ],
      },
      // 账户列表
      accountList: [],
      // 列表组件参数
      basicListconfig: {
        loading: false,
        search: [
          {
            label: "编号",
            type: "inputNumber",
            key: "id",
            width: 100,
          },
          {
            label: "名称/电话/昵称",
            type: "input",
            key: "keywords",
          },
          {
            label: "分类",
            type: "select",
            key: "type_id",
            options: [
              {
                value: 1,
                label: "同行",
              },
              {
                value: 2,
                label: "分销",
              },
              {
                value: 3,
                label: "团购",
              },
              {
                value: 4,
                label: "外卖",
              },
              {
                value: 5,
                label: "零售(POS)",
              },
            ],
          },
          {
            label: "状态",
            key: "status",
            type: "select",
            options: [
              {
                label: "激活",
                value: 0,
              },
              {
                label: "锁定",
                value: 1,
              },
            ],
          },
        ],
        data: [],
        column: [
          // {
          //   label: "编号",
          //   prop: "id",
          //   width: 50,
          // },
          {
            label: "名称（昵称）",
            prop: "name",
            width: 150,
          },
          // {
          //   label: "昵称",
          //   prop: "nick_name",
          //   width: 200,
          // },
          {
            label: "关联店员",
            prop: "user_name",
          },
          {
            label: "分类",
            prop: "type_id",
            filter: "customerClassification",
          },
          {
            label: "交易金额",
            prop: "total_pay_monye",
            isMoney: true,
            sortable: true,
          },
          {
            label: "交易次数",
            prop: "pay_count",
            sortable: true,
          },
          {
            label: "余额",
            isMoney: true,
            prop: "money",
            sortable: true,
          },
          {
            label: "上次交易时间",
            prop: "last_pay_time",
            width: 120,
            sortable: true,
          },
          {
            label: "状态",
            prop: "status",
            filter: "storeStatus",
          },
        ],
        isPage: true,
        total: 0,
        operationWidth: 350,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    // 初始化列表内容
    this.getlist();
    // 获取账户列表
    this.getAccountList();
  },
  computed: {
    ...mapGetters(["hasPermission"]),
  },
  methods: {
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认锁定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        customerLock({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认激活?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        customerActive({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        customerDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters["comp_id"] = this.compId;
      this.basicListconfig.searchParameters.is_showAll = 1;
      customerGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取账户列表
    getAccountList() {
      companyAccountGetList({
        comp_id: this.compId,
        is_showAll: 1,
        limit: 1000
      }).then((res) => {
        if (res.code == 1) {
          this.accountList = res.data.map(item => ({
            label: item.account_name,
            value: item.id
          }));
        }
      });
    },
    // 充值方法
    recharge(row) {
      this.rechargeDialog.customer_id = row.id;
      this.rechargeDialog.customer_name = row.name;
      this.rechargeDialog.account_id = "";
      this.rechargeDialog.amount = "";
      this.rechargeDialog.remark = "";
      this.rechargeDialog.visible = true;
    },
    // 提交充值
    submitRecharge() {
      this.$refs.rechargeForm.validate((valid) => {
        if (valid) {
          const data = {
            comp_id: this.compId,
            shop_id: 0,
            pay_id: this.rechargeDialog.account_id,
            money: Number(this.rechargeDialog.amount) * 100,
            user_id: this.userId,
            remark: this.rechargeDialog.remark,
            flow_type: 8, // 客户余额充值
            sub_type: 0,
            customer_id: this.rechargeDialog.customer_id
          };
          billAdd(data).then((res) => {
            if (res.code == 1) {
              this.$message.success("充值成功");
              this.rechargeDialog.visible = false;
              this.getlist();
            } else {
              this.$message.error(res.msg || "充值失败");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/customerManagement/index.vue